import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const FloridaInternationalUniversity = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="Florida International University"
      universityShortName="FIU"
      slug="florida-international-university"
      seoTitle="FIU Study Rooms | Florida International University Study Spaces"
      seoDescription="Find study rooms at FIU including the Law Library group rooms. Learn booking policies, quiet zones, and discover CSW as an online alternative."
      seoKeywords="FIU study rooms, Florida International University library, FIU law library, Miami study spaces, FIU group study rooms"
      canonicalUrl="/study-room/florida-international-university/"
      heroDescription="Navigate FIU's study room options from the main library to the controlled Law Library environment."
      libraryWebsiteUrl="https://library.fiu.edu"
      libraryWebsiteName="FIU Libraries"
      studySpaces={[
        {
          name: "FIU Law Library - Group Rooms",
          features: "20 rooms seating 2-6 students, up to 3 hours. Keys at circulation desk.",
          feedback: "Quieter, more controlled environment. Popular with bar exam prep students."
        },
        {
          name: "Green Library - Main Floor",
          features: "Open collaborative spaces, casual seating areas.",
          feedback: "Can be crowded and noisy. Often more social hub than study space."
        },
        {
          name: "Green Library - Quiet Zones",
          features: "Designated quiet study areas, individual carrels.",
          feedback: "Better for focused work. Bring earplugs during busy hours."
        }
      ]}
      guideContent={
        <>
          <p>
            FIU Law Library offers 20 group study rooms, each seating 2-6 students. Rooms may be reserved by 
            FIU law students and alumni preparing for the bar exam for up to three hours.
          </p>
          <p className="mt-4">
            Keys must be checked out at the circulation desk and unreserved rooms are available on a first-come basis. 
            The main library can be crowded and noisy—some call it a social hub rather than a study space.
          </p>
          <p className="mt-4">
            Use the main library for casual study or socializing; for serious work, head to the Law Library's 
            group rooms or quiet zones. Bring earplugs if you stay in the general library and take advantage of off-peak hours.
          </p>
        </>
      }
      summaryTips={[
        "Law Library has 20 group rooms for up to 3 hours",
        "Pick up room keys at the circulation desk",
        "Main library can be noisy during peak hours",
        "Off-peak hours offer better focus",
        "Bring earplugs for the general library areas"
      ]}
    />
  );
};

export default FloridaInternationalUniversity;
